import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import "./styles.css";

registerSW({ immediate: true });

// Keep audit data on the device: ask the browser for persistent storage once.
if (navigator.storage?.persist) {
  navigator.storage.persist().catch(() => undefined);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
